import { ArrowLeftIcon, IconButton } from "@datagame/ui";
import { useTranslation } from "react-i18next";

import { Step } from "../Step";

import styles from "./Navigation.module.scss";

export interface NavigationProps {
  onBack: () => void;
  steps: number[];
  activeStep: number;
}

export const Navigation = ({ onBack, steps, activeStep }: NavigationProps) => {
  const { t } = useTranslation("account");

  const isFirstStep = activeStep === 1;

  return (
    <div className={styles.navigation}>
      <IconButton disabled={isFirstStep} icon={<ArrowLeftIcon />} text={t("back")} onClick={onBack} />

      <div className={styles.steps}>
        {steps.map((step, index) => {
          return <Step key={index} step={step} isActive={step <= activeStep} />;
        })}
      </div>
    </div>
  );
};
